import { formatDate } from "../components/Input";

export function areMetersEqual(m1, m2) {
  if (m1.note !== m2.note) return false;
  if (m1.reading !== m2.reading) return false;
  if (formatDate(m1.date) !== formatDate(m2.date)) return false

  return true;
}

export function areCropsEqual(c1, c2) {
  if (c1.name !== c2.name) return false;
  if (c1.yield !== c2.yield) return false;
  if (c1.yieldUnits !== c2.yieldUnits) return false;
  if (c1.yieldGoal !== c2.yieldGoal) return false;
  if (c1.hasDamage !== c2.hasDamage) return false;
  if (c1.year !== c2.year) return false;
  if (c1.irrigation.sprinkler !== c2.irrigation.sprinkler) return false;
  if (c1.irrigation.flood !== c2.irrigation.flood) return false;
  if (c1.irrigation.other !== c2.irrigation.other) return false;
  if (c1.irrigationApplied !== c2.irrigationApplied) return false;
  if (c1.waterNitrate !== c2.waterNitrate) return false;
  if (c1.tillage !== c2.tillage) return false;
  if (c1.note !== c2.note) return false;

  if (c1.manureApplications?.length !== c2.manureApplications?.length) return false;
  if (c1.nitrogenApplications?.length !== c2.nitrogenApplications?.length) return false;

  // If the lengths match we have to check the actual values.
  const manureItemsDiffer = c1.manureApplications?.some((m1, i) => {
    const m2 = c2.manureApplications[i];

    if (m1.deleted || m2.deleted) return true;

    // FIXME: Need a better date comparison.
    if (m1.date.toString() !== m2.date.toString()) return true;
    if (m1.type !== m2.type) return true;
    if (m1.ammoniumNitrogen !== m2.ammoniumNitrogen) return true;
    if (m1.organicNitrogen !== m2.organicNitrogen) return true;
    if (m1.amount !== m2.amount) return true;
    if (m1.method !== m2.method) return true;

    return false;
  });

  if (manureItemsDiffer) return false;

  const nitrogenItemsDiffer = c1.nitrogenApplications?.some((n1, i) => {
    const needSwap = Object.keys(n1).includes("isAdvanced");
    // Make sure n2 is always the changed version and n1 is always the one derived from the API data
    const n2 = needSwap ? n1 : c2.nitrogenApplications[i];
    n1 = needSwap ? c2.nitrogenApplications[i] : n1;

    if (n2.deleted) return true;

    // FIXME: Need a better date comparison.
    if (n1.date.toString() !== n2.date.toString()) return true;
    if (n1.emergenceType !== n2.emergenceType) return true;
    if (n2.isAdvanced) {
      // These fields only need to match if the application is advanced
      if (n1.type !== n2.type) return true;
      if (n1.amount !== n2.amount) return true;
      if (n1.units !== n2.units) return true;
      if (n1.nitrogen !== n2.nitrogen) return true;
      if (n1.phosphate !== n2.phosphate) return true;
      if (n1.potassium !== n2.potassium) return true;
      if (n1.density !== n2.density) return true;
    } else {
      // This field only needs to match when not advanced.
      if (n1.nitrogenApplied !== n2.nitrogenApplied) return true;
    }
    if (n1.inhibitorUsed !== n2.inhibitorUsed) return true;
    if (n1.inhibitorType !== n2.inhibitorType) return true;

    return false;
  });

  if (nitrogenItemsDiffer) return false;

  return true;
}

export function areSamplesEqual(s1, s2) {
  if (s1.name !== s2.name) return false;
  if (s1.locationId !== s2.locationId) return false;
  if (s1.acres !== s2.acres) return false;
  if (s1.texture !== s2.texture) return false;
  if (s1.isComposite !== s2.isComposite) return false;
  // FIXME: Need a better date comparison.
  if (s1.labDate.toString() !== s2.labDate.toString()) return false;
  if (s1.sampleDate.toString() !== s2.sampleDate.toString()) return false;
  if (s1.lab !== s2.lab) return false;
  if (s1.note !== s2.note) return false;

  if (s1.layers?.length !== s2.layers.length) return false;

  // Otherwise they have the same length so we have to check all the items.
  const layersDiffer = s1.layers?.some((l1, i) => {
    const l2 = s2.layers[i];

    // Definitely different if one of them was deleted.
    if (l1.deleted || l2.deleted) return true;

    if (l1.top !== l2.top) return true;
    if (l1.bottom !== l2.bottom) return true;
    if (l1.calcium !== l2.calcium) return true;
    if (l1.cations !== l2.cations) return true;
    if (l1.magnesium !== l2.magnesium) return true;
    if (l1.nitrate !== l2.nitrate) return true;
    if (l1.organicMatter !== l2.organicMatter) return true;
    if (l1.ph !== l2.ph) return true;
    if (l1.phosphate !== l2.phosphate) return true;
    if (l1.potassium !== l2.potassium) return true;
    if (l1.sodium !== l2.sodium) return true;
    if (l1.solubleSalts !== l2.solubleSalts) return true;
    if (l1.sulfate !== l2.sulfate) return true;

    // NOTE: We don't actually care about layer number here.

    return false;
  });

  return !layersDiffer;
}
